export const GET_DELIVERY_DEVICES = 'get_delivery_devices';
